export default {
    "北京银行" : {
        bgro: require("@/assets/img/bank/beijing/bgro.jpg")    ,
        logo: require("@/assets/img/bank/beijing/logo.png")    ,
    },
    "工商银行" : {
        bgro: require("@/assets/img/bank/gongshang/bgro.jpg")    ,
        logo: require("@/assets/img/bank/gongshang/logo.png")    ,
    },
    "光大银行" : {
        bgro: require("@/assets/img/bank/guangda/bgro.jpg")    ,
        logo: require("@/assets/img/bank/guangda/logo.png")    ,
    },
    "广发银行" : {
        bgro: require("@/assets/img/bank/guangfa/bgro.jpg")    ,
        logo: require("@/assets/img/bank/guangfa/logo.png")    ,
    },
    "杭州银行" : {
        bgro: require("@/assets/img/bank/hangzhou/bgro.jpg")    ,
        logo: require("@/assets/img/bank/hangzhou/logo.png")    ,
    },
    "华夏银行" : {
        bgro: require("@/assets/img/bank/huaxia/bgro.jpg")    ,
        logo: require("@/assets/img/bank/huaxia/logo.png")    ,
    },
    "建设银行" : {
        bgro: require("@/assets/img/bank/jianshe/bgro.jpg")    ,
        logo: require("@/assets/img/bank/jianshe/logo.png")    ,
    },
    "交通银行" : {
        bgro: require("@/assets/img/bank/jiaotong/bgro.jpg")    ,
        logo: require("@/assets/img/bank/jiaotong/logo.png")    ,
    },
    "农业银行" : {
        bgro: require("@/assets/img/bank/nongye/bgro.jpg")    ,
        logo: require("@/assets/img/bank/nongye/logo.png")    ,
    },
    "平安银行" : {
        bgro: require("@/assets/img/bank/pingan/bgro.jpg")    ,
        logo: require("@/assets/img/bank/pingan/logo.png")    ,
    },
    "浦发银行" : {
        bgro: require("@/assets/img/bank/pufa/bgro.jpg")    ,
        logo: require("@/assets/img/bank/pufa/logo.png")    ,
    },
    "上海银行" : {
        bgro: require("@/assets/img/bank/shanghai/bgro.jpg")    ,
        logo: require("@/assets/img/bank/shanghai/logo.png")    ,
    },
    "兴业银行" : {
        bgro: require("@/assets/img/bank/xingye/bgro.jpg")    ,
        logo: require("@/assets/img/bank/xingye/logo.png")    ,
    },
    "邮储银行" : {
        bgro: require("@/assets/img/bank/youzheng/bgro.jpg")    ,
        logo: require("@/assets/img/bank/youzheng/logo.png")    ,
    },
    "中国银行" : {
        bgro: require("@/assets/img/bank/zhongguo/bgro.jpg")    ,
        logo: require("@/assets/img/bank/zhongguo/logo.png")    ,
    },
    "中信银行" : {
        bgro: require("@/assets/img/bank/zhongxin/bgro.jpg")    ,
        logo: require("@/assets/img/bank/zhongxin/logo.png")    ,
    },
    "民生银行" : {
        bgro: require("@/assets/img/bank/minsheng/bgro.jpg")    ,
        logo: require("@/assets/img/bank/minsheng/logo.png")    ,
    },
    "招商银行" : {
        bgro: require("@/assets/img/bank/zhangshang/bgro.jpg")    ,
        logo: require("@/assets/img/bank/zhangshang/logo.png")    ,
    },
    "宁波银行" : {
      bgro: require("@/assets/img/bank/ningbo/bgro.jpg")    ,
      logo: require("@/assets/img/bank/ningbo/logo.png")    ,
    },
    "广州银行" : {
      bgro: require("@/assets/img/bank/guangzhou/bgro.jpg")    ,
      logo: require("@/assets/img/bank/guangzhou/logo.png")    ,
    },
    "浙商银行" : {
        bgro: ""    ,
        logo: ""    ,
    },
}